var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9 7C24.9 6.50294 24.4971 6.1 24 6.1C19.6686 6.1 15.4345 7.38441 11.833 9.79081C8.23158 12.1972 5.42461 15.6175 3.76705 19.6192C2.10949 23.6209 1.6758 28.0243 2.52081 32.2725C3.36583 36.5207 5.4516 40.4229 8.51437 43.4856C11.5771 46.5484 15.4793 48.6342 19.7275 49.4792C23.9757 50.3242 28.3791 49.8905 32.3808 48.233C36.3825 46.5754 39.8028 43.7684 42.2092 40.167C44.6156 36.5655 45.9 32.3314 45.9 28C45.9 27.5029 45.4971 27.1 45 27.1H24.9V7Z",
    fill: "white",
    stroke: "#0045A4",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 23.1C47.6332 23.1 48.058 22.6022 48.0089 22.0886C47.8194 20.1045 47.3354 18.156 46.57 16.3081C45.5599 13.8694 44.0793 11.6536 42.2128 9.78716C40.3464 7.9207 38.1306 6.44014 35.6919 5.43002C33.844 4.66457 31.8955 4.18062 29.9114 3.99109C29.3978 3.94202 28.9 4.36684 28.9 5L28.9 22C28.9 22.6075 29.3925 23.1 30 23.1H47Z",
    fill: "#C2DCFF",
    stroke: "#0045A4",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.d851f785.svg";
export { ForwardRef as ReactComponent };